<template>
    <div class="piscreen">

        <div class="topBar">
            <div class="home">
                <a href="/"><font-awesome-icon icon="home" /></a>
            </div>
        </div>

        <main>
            <h1>Patch Notes</h1>
            
            <div class="patchnote" v-for="(patchNote, index) in patchNotes">
                <p><strong>Versie {{ patchNote.version }}</strong><br>{{ patchNote.date }}</p>
                <h2 v-if="patchNote.major">{{ patchNote.major }}</h2>
                <h3 v-if="patchNote.minor">{{ patchNote.minor }}</h3>
                <ul>
                    <li v-for="note in patchNote.notes">{{ note }}</li>
                </ul>
                <hr v-if="index != patchNotes.length - 1">
            </div>

        </main>


    </div>

</template>

<script>



export default {

    name: 'PatchNotes',

    // components: {
    //     StatusMessage: StatusMessage,
    //     Keyboard: Keyboard
    // },

    data() {
        return {
            patchNotes: [
                {
                    version: '1.5.1',
                    date: '27 januari 2020',
                    major: '',
                    minor: '',
                    notes: [
                        'Persoonlijke Statistieken pagina design verbeterd (minder druk).'
                    ]
                },

                {
                    version: '1.5.0',
                    date: '27 januari 2020',
                    major: '',
                    minor: 'Persoonlijke statistieken toegevoegd',
                    notes: [
                        'Er is nu een scherm voor persoonlijke statistieken (link in de bovenste navigatie balk).',
                        'Je kan hier kijken wat je in totaal gegooid hebt (alle seizoenen bij elkaar). Zo kun je gericht gooien op de laatste scores die je nodig hebt voor specifieke titels.'
                    ]
                },

                {
                    version: '1.4.0',
                    date: '24 januari 2020',
                    major: '',
                    minor: 'Titels toegevoegd',
                    notes: [
                        'Je kan nu titels verdienen door bepaalde scores te gooien (meestal alles van 1 categorie).',
                        'Je kan een titel kiezen op het Optie scherm (via een link in de bovenste navigatie balk).',
                        'De titel die je kiest wordt weergegeven op het leaderboard, onder je naam.',
                        'Andere veranderingen:',
                        'Leaderboard heeft nu icoontjes bij elke speler, afhankelijk van hun rang.',
                        'Bug gefixt die ervoor zorgde dat er ongeldige waarden in de database kwamen, waardoor het leaderboard kapot ging.'
                    ]
                },

                {
                    version: '1.3.10',
                    date: '14 januari 2020',
                    major: '',
                    minor: '',
                    notes: [
                        'Spelers met evenveel punten staan nu gelijk op het leaderboard. Eerder stond degene voor die alfabetisch eerder kwam.'
                    ]
                },

                {
                    version: '1.3.9',
                    date: '10 januari 2020',
                    major: '',
                    minor: '',
                    notes: [
                        'Patch notes toegevoegd.',
                        '\'Regular\' varianten van FontAwesome icoontjes toegevoegd. Er wordt er maar liefst 1 gebruikt op dit moment!'
                    ]
                },

                {
                    version: '1.3.7',
                    date: '9 januari 2020',
                    major: '',
                    minor: '',
                    notes: [
                        'Je kan nu de leaderboards van vorige seizoenen terugkijken.'
                    ]
                },

                {
                    version: '1.3.6',
                    date: '7 januari 2020',
                    major: '',
                    minor: '',
                    notes: [
                        'Pijl omhoog toegevoegd aan het sticky nav menu op het Home scherm, waarmee je naar de bovenkant van de pagina gaat.'
                    ]
                },

                {
                    version: '1.3.5',
                    date: '24 december 2019',
                    major: '',
                    minor: 'Seizoenen toegevoegd',
                    notes: [
                        'In elk nieuw seizoen (waarschijnlijk elk jaar) worden alle scores gereset.',
                        'De vorige scores worden wel bewaard voor toekomstige leaderboards en andere features.',
                        'Andere veranderingen:',
                        'Leaderboard laat nu alleen spelers zien die minstens 1 punt hebben.',
                        'Het keyboard component is nu ook te gebruiken op andere pagina\'s.',
                        'Het keyboard component heeft nu ook een optie voor alleen numpad of letters, en kan input maskeren op het scherm.',
                        'Popup bericht bij scores/spelers aanpassen heeft nu een optie om niet te redirecten naar het Home scherm.',
                        'De Admin pagina is nu makkelijker toegankelijk, maar beter beveiligd.',
                        'De Admin pagina is iets minder lelijk.',
                        'Database endpoints aangepast naar nieuwe DB layout.',
                        'Standaard HelloWorld component weggegooid :P'
                    ]
                },

                {
                    version: '1.2.1',
                    date: '12 december 2019',
                    major: '',
                    minor: '',
                    notes: [
                        'Sticky nav menu toegevoegd op het Home scherm voor makkelijker scrollen tussen categorieën.'
                    ]
                },

                {
                    version: '1.2.0',
                    date: '7 maart 2019',
                    major: '',
                    minor: 'Leaderboard toegevoegd',
                    notes: [
                        'Op het leaderboard zie je de scores van alle spelers, gerangschikt van hoog naar laag.',
                        'Alles dat je gooit is 1 punt waard. Dit is om te zorgen dat iemand die met puur geluk iets heel moeilijks gooit niet direct naar de top van de lijst schiet.',
                    ]
                },

                {
                    version: '1.1.1',
                    date: '6 maart 2019',
                    major: '',
                    minor: '',
                    notes: [
                        'Fix voor spelers aan/uit zetten op Admin scherm. Dit bleek niet te werken op de Raspberry Pi maar wel in de Windows dev omgeving.',
                        'Reminder voor de toekomst: sommige webservers maken geen verschil in hoofdletters/kleine letters in bestandsnamen; anderen weer wel.',
                        'Gelukkig heb ik absoluut geen uren hoeven zoeken naar de oorzaak van het probleem... :P'
                    ]
                },

                {
                    version: '1.1.0',
                    date: '5 maart 2019',
                    major: '',
                    minor: 'Admin pagina toegevoegd',
                    notes: [
                        'Op de Admin pagina kun je spelers aan/uit zetten.',
                        'Spelers die uit staan worden niet getoond bij het toevoegen van scores.'
                    ]
                },

                {
                    version: '1.0.6',
                    date: '5 maart 2019',
                    major: '',
                    minor: '',
                    notes: [
                        'Spelers met evenveel punten in een categorie worden nu alfabetisch gesorteerd.'
                    ]
                },

                {
                    version: '1.0.5',
                    date: '1 maart 2019',
                    major: '',
                    minor: '',
                    notes: [
                        'Spelers worden nu per categorie gerangschikt van meest gegooid naar minst gegooid.'
                    ]
                },

                {
                    version: '1.0.4',
                    date: '28 februari 2019',
                    major: '',
                    minor: '',
                    notes: [
                        'Na het toevoegen van een score scrollt de app vanzelf weer terug naar de betreffende categorie op het Home scherm.',
                        'Sommige knoppen zijn nu makkelijker klikbaar.',
                        'Alétho logo en tekst toegevoegd aan footer.',
                        'Icoontjes toegevoegd op verschillende plaatsen.',
                    ]
                },

                {
                    version: '1.0.0',
                    date: '24 februari 2019',
                    major: 'Versie 1 is af!',
                    minor: '',
                    notes: [
                        'Dit is de eerste versie die bij Alétho Assen in gebruik gaat. Als het goed is moet het onderstaande allemaal werken...',
                        'Op het Home scherm zie je een overzicht van wat elke speler gegooid heeft. Dit is verdeelt in categorieën: Singles, Doubles (2x), Doubles (3x), Triples (2x), Triples (3x), Shanghai, Robinhood, Bull.',
                        'Je kan spelers aanmaken.',
                        'Je kan scores toevoegen.',
                        'Je kan scores verwijderen.',
                    ]
                }

            ],


            
        }
        
    },

    

    methods: {
        dismissStatusMessage() {
            this.statusMessage = '';
            this.loadUsers();
        }




    },

    


    mounted() {
        // this.loadUsers();
        // this.getAllSeasons();
        // this.route = this.$root.currentRoute;
        
    }
}
</script>


<style scoped>

    @font-face {
        font-family: SegoeUI;
        src: url("../../Segoe UI.ttf");
    }

    * {
        font-family: "SegoeUI";
        box-sizing: border-box;
    }
    
    html {
        overflow-x: hidden;
        margin: 0;
        padding: 0;
    }

    body {
        margin: 0;
        background: #444;
        color: #000;
        font-family: "SegoeUI";
        /*overflow-x: hidden;*/
        
        padding: 0;

    }

    .piscreen {
        width: 800px;
        background: #eee;
        min-height: 480px;
    }


    .topBar {
        background: #ddd;
        /*padding: 20px;*/
        justify-content: space-between;
        display: flex;
        border-bottom: 1px solid #aaa;

        position: sticky;
        top: 0px;
    }

    main {
        padding: 0 20px 20px;
    }

    main h1 {
        text-align: center;
    }

    .home {
        /*position: absolute;*/
        font-size: 32px;
        /*border: 1px solid #558b2f;*/
        border: 1px solid #bbb;
        margin: 15px;
        box-shadow: 1px 1px 3px rgba(0,0,0,0.24);
        /*background: #aed581;*/
        background: #fff;
        border-radius: 3px;
        /*height: 60px;*/
        /*left: 0px;*/
        /*top: 0px;*/
        cursor: pointer;
        user-select: none;
    }
    .home a {
        text-decoration: none;
        padding: 5px 15px 10px;
        display: block;
        color: #000;
    }

    nav ul {
        margin: 0;
        padding: 0;
        list-style-type: none;
        border-bottom: 1px solid #aaa;
    }

    nav ul li {
        display: inline-block;
        padding: 20px 40px;
        background: #ddd;
        border-right: 1px solid #aaa;
        font-weight: bold;
    }

    nav ul li.active {
        background: darkseagreen;
    }

    hr {
        margin-top: 30px;
        margin-bottom: 30px;
        border-top: 1px solid #ccc;
    }

</style>
